import { TranslationFileName } from "../translationFiles";

type TranslationBundle = Record<string, unknown>;
type BundleImport = () => Promise<{ default: TranslationBundle }>;

export const TRANSLATION_BUNDLE_IMPORTS: Partial<Record<`${string}/${TranslationFileName}`, BundleImport>> = {
  "de/common": () => import("../../../../public/locales/de/common.json"),
  "de/donationForm": () => import("../../../../public/locales/de/donationForm.json"),
  "de/ticketing": () => import("../../../../public/locales/de/ticketing.json"),
  "de/dashboard": () => import("../../../../public/locales/de/dashboard.json"),
  "de/campaignHub": () => import("../../../../public/locales/de/campaignHub.json"),
  "de/organization": () => import("../../../../public/locales/de/organization.json"),
  "de-DE/common": () => import("../../../../public/locales/de-DE/common.json"),
  "en/common": () => import("../../../../public/locales/en/common.json"),
  "en/donationForm": () => import("../../../../public/locales/en/donationForm.json"),
  "en/ticketing": () => import("../../../../public/locales/en/ticketing.json"),
  "en/dashboard": () => import("../../../../public/locales/en/dashboard.json"),
  "en/campaignHub": () => import("../../../../public/locales/en/campaignHub.json"),
  "en/organization": () => import("../../../../public/locales/en/organization.json"),
  "en-AU/common": () => import("../../../../public/locales/en-AU/common.json"),
  "en-AU/donationForm": () => import("../../../../public/locales/en-AU/donationForm.json"),
  "en-AU/ticketing": () => import("../../../../public/locales/en-AU/ticketing.json"),
  "en-AU/dashboard": () => import("../../../../public/locales/en-AU/dashboard.json"),
  "en-AU/campaignHub": () => import("../../../../public/locales/en-AU/campaignHub.json"),
  "en-AU/organization": () => import("../../../../public/locales/en-AU/organization.json"),
  "en-CA/common": () => import("../../../../public/locales/en-CA/common.json"),
  "en-CA/donationForm": () => import("../../../../public/locales/en-CA/donationForm.json"),
  "en-CA/ticketing": () => import("../../../../public/locales/en-CA/ticketing.json"),
  "en-CA/dashboard": () => import("../../../../public/locales/en-CA/dashboard.json"),
  "en-DE/common": () => import("../../../../public/locales/en-DE/common.json"),
  "en-DE/dashboard": () => import("../../../../public/locales/en-DE/dashboard.json"),
  "en-GB/common": () => import("../../../../public/locales/en-GB/common.json"),
  "en-GB/donationForm": () => import("../../../../public/locales/en-GB/donationForm.json"),
  "en-GB/ticketing": () => import("../../../../public/locales/en-GB/ticketing.json"),
  "en-GB/dashboard": () => import("../../../../public/locales/en-GB/dashboard.json"),
  "en-GB/campaignHub": () => import("../../../../public/locales/en-GB/campaignHub.json"),
  "en-GB/organization": () => import("../../../../public/locales/en-GB/organization.json"),
  "en-IE/common": () => import("../../../../public/locales/en-IE/common.json"),
  "en-IE/donationForm": () => import("../../../../public/locales/en-IE/donationForm.json"),
  "en-IE/ticketing": () => import("../../../../public/locales/en-IE/ticketing.json"),
  "en-IE/dashboard": () => import("../../../../public/locales/en-IE/dashboard.json"),
  "en-US/common": () => import("../../../../public/locales/en-US/common.json"),
  "en-US/dashboard": () => import("../../../../public/locales/en-US/dashboard.json"),
  "en-US/campaignHub": () => import("../../../../public/locales/en-US/campaignHub.json"),
  "es/common": () => import("../../../../public/locales/es/common.json"),
  "es/donationForm": () => import("../../../../public/locales/es/donationForm.json"),
  "es/ticketing": () => import("../../../../public/locales/es/ticketing.json"),
  "es/dashboard": () => import("../../../../public/locales/es/dashboard.json"),
  "es-US/dashboard": () => import("../../../../public/locales/es-US/dashboard.json"),
  "fr/common": () => import("../../../../public/locales/fr/common.json"),
  "fr/donationForm": () => import("../../../../public/locales/fr/donationForm.json"),
  "fr/ticketing": () => import("../../../../public/locales/fr/ticketing.json"),
  "fr/dashboard": () => import("../../../../public/locales/fr/dashboard.json"),
  "fr/campaignHub": () => import("../../../../public/locales/fr/campaignHub.json"),
  "fr/organization": () => import("../../../../public/locales/fr/organization.json"),
  "fr-CA/donationForm": () => import("../../../../public/locales/fr-CA/donationForm.json"),
  "fr-CA/dashboard": () => import("../../../../public/locales/fr-CA/dashboard.json"),
};
